
// Number means maximum days user can choose
export const KEYWORD_TIME_RANGE_MAP = {
    free: 3,
    basic: 30,
    pro: 999999
}